import Button from './button';
import NoticeBar from './notice-bar';
import Badge from './badge';
import {
  TabBar,
  TabBarItem,
} from './tab-bar';
import Divider from './divider';
import Footer from './footer';
import Overlay from './overlay';
import Popup from './popup';
import Toast from './toast';
import Switch from './switch';
import Tag from './tag';
import ActionSheet from './action-sheet';
import Keyboard from './keyboard';
import AmountInput  from './amount-input';
import AmountBox from './amount-box';
import KeyboardInput  from './keyboard-input';
import List from './list';
import { Radio, RadioGroup } from './radio';
import { Checkbox, CheckboxGroup } from './checkbox';
import Result from './result';
import HalfScreenDialog from './half-screen-dialog';
import Dialog from './dialog';
import { Tabs, TabItem } from './tabs';
import ScrollView from './scroll-view';
import FormPreview from './form-preview';
import { Step, StepItem } from './step';
import Cell, { CellGroup } from './cell';
import SwipeCell from './swipe-cell';
import Avatar from './avatar';
import Picker from './picker';
import DatePicker from './date-picker';
import Tooltip from './tooltip';
import Search from './search';
import NavBar from './nav-bar';
import Input from './input';
import Textarea from './textarea';
import { Form, FormItem } from './form';

export type { ActionSheetAction, ActionSheetProps } from './action-sheet';
export type { FormProps, FormItemProps, FormRule, FormRules, FormTrigger, FormValidateError, FormLayout, FormLabelAlign, ValidateMessages } from './form';
export { FORM_KEY, FORM_ITEM_KEY } from './form';
export type { PickerProps, PickerOption, PickerFieldNames, PickerEventParams, PickerChangeEventParams } from './picker';
export type { DatePickerProps, DatePickerColumnType, DatePickerEventParams, DatePickerChangeEventParams, DatePickerFormatter, DatePickerFilter } from './date-picker';
export type { TooltipProps, TooltipArrowPosition } from './tooltip';
export type { NavBarProps } from './nav-bar';
export type { SwipeCellProps, SwipeAction, SwipeActionLayout, SwipeActionColor, SwipeActionConfirm, SwipeCellState, SwipeCloseReason, SwipeClickPosition, SwipeActionContext, SwipeStateContext, BeforeCloseParams } from './swipe-cell';

const components = [
  Button,
  NoticeBar,
  Badge,
  TabBar,
  TabBarItem,
  Divider,
  Footer,
  Overlay,
  Popup,
  Toast,
  Switch,
  Tag,
  ActionSheet,
  Keyboard,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  AmountInput,
  AmountBox,
  KeyboardInput,
  List,
  Result,
  HalfScreenDialog,
  Dialog,
  Tabs,
  TabItem,
  ScrollView,
  FormPreview,
  Step,
  StepItem,
  Cell,
  SwipeCell,
  Avatar,
  Picker,
  DatePicker,
  Tooltip,
  Search,
  Input,
  Textarea,
  Form,
  FormItem,
  NavBar,
];

const install = function (Vue) {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};

const globalVue = typeof window !== 'undefined'
  ? (window as Window & { Vue?: any }).Vue
  : undefined;

if (globalVue) {
  install(globalVue);
}

export { showToast, hideToast } from './toast';

export { showDialog, hideDialog } from './dialog';
export type { DialogAction, DialogOptions } from './dialog';

export { i18n, i18nInstance } from './i18n';
export type { InterpolationData, LanguageConfig, LanguageMap } from './i18n';

export {
  install,
  Button,
  NoticeBar,
  Badge,
  TabBar,
  TabBarItem,
  Divider,
  Footer,
  Overlay,
  Popup,
  Toast,
  Switch,
  Tag,
  ActionSheet,
  Keyboard,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  AmountInput,
  AmountBox,
  KeyboardInput,
  List,
  Result,
  HalfScreenDialog,
  Dialog,
  Tabs,
  TabItem,
  ScrollView,
  FormPreview,
  Step,
  StepItem,
  Cell,
  CellGroup,
  SwipeCell,
  Avatar,
  Picker,
  DatePicker,
  Tooltip,
  Search,
  NavBar,
  Input,
  Textarea,
  Form,
  FormItem,
};

export type { SearchProps, SearchTheme, SearchClearTrigger } from './search';
